import TYPES from '@/modules/shared/types';

// Domain
import {
  AnonymousTicketRepository,
} from '@/modules/zendesk/anonymous-ticket/domain/repositories/anonymous-ticket-repository';
import {
  AnonymousTicketDto,
} from '@/modules/zendesk/anonymous-ticket/domain/dtos/anonymous-ticket-dto';
import Injectable from '@/modules/shared/domain/di/injectable';
import Inject from '@/modules/shared/domain/di/inject';
import HttpConnector from '@/modules/shared/domain/connectors/http';

@Injectable()
export default class AnonymousTicketHttpRepository implements AnonymousTicketRepository {
  @Inject(TYPES.HTTP_CONNECTOR)
  private readonly http_connector!: HttpConnector;

  private readonly endpoint = `${process.env.VUE_APP_API_URL}/api/v1/app/onboarding/zendesk/anonymous-ticket/`;

  create(anonymous_ticket_dto: AnonymousTicketDto): Promise<void> {
    return new Promise((resolve, reject) => {
      this.http_connector.execute(this.endpoint, 'POST', anonymous_ticket_dto)
        .then((response) => {
          response.json()
            .then(({ success, data, message }) => {
              if (success) {
                resolve(data);
              } else {
                reject(new Error(message));
              }
            });
        })
        .catch(reject);
    });
  }
}
